import React, { ReactNode } from 'react';
import { Row, Col } from 'antd';
import InfoCard, { InfoCardType } from '../InfoCard';
import withSkeleton from '../../hoc/withSkeleton';
import InfoCardListSkeleton from './InfoCardListSkeleton';
import { GridType } from '../../types';

export type InfoCardListProps = {
  infoList: InfoCardType[];
  renderItem?: (item: any, index: number) => ReactNode;
  grid: GridType;
};

const InfoCardList: React.FC<InfoCardListProps> = ({
  infoList,
  renderItem,
  grid,
}) => {
  return (
    <Row {...grid?.row}>
      {infoList.map((item, index) => {
        if (renderItem) {
          if (grid?.col) {
            return (
              <Col key={index} {...grid.col}>
                {renderItem(item, index)}
              </Col>
            );
          }
          return renderItem(item, index);
        }

        return (
          <Col {...grid?.col} key={item.id}>
            <InfoCard data={item} />
          </Col>
        );
      })}
    </Row>
  );
};

export default withSkeleton(InfoCardList, InfoCardListSkeleton);
